import { Action, Mutation, Module } from "vuex-class-modules";
import Axios, { AxiosResponse } from "axios";
import AxiosSecureModule from "./axiosSecureModule";
import { Log } from "@/plugins/Logging";

@Module()
export default class EnrollModule extends AxiosSecureModule {
    EnrollInProgress = false;
    EnrollStartedAt: Date = new Date();
    @Action
    public start() {
        this.setEnrollProgres(true);
        this.setEnrollStartTime();
    }
    @Action
    public async StartEnroll(id: number) {
        this.setEnrollProgres(false);
        await this.defineHeaderAxios();
        Axios.get(`api/sensor/enroll/${id}`)
            .then((result: AxiosResponse) => {
                Log.information(result.statusText);
            })
            .catch((error) => {
                Log.error("", error);
            });
    }

    @Action
    public end() {
        this.setEnrollProgres(false);
    }
    @Mutation
    public setEnrollProgres(value: boolean) {
        this.EnrollInProgress = value;
    }
    @Mutation
    public setEnrollStartTime() {
        this.EnrollStartedAt = new Date();
    }
}
